module.exports = __webpack_public_path__ + "static/jared-5c71989553e7d274d7f9efc2b4c16578.jpg";